import { render, staticRenderFns } from "./EditDeadlineModal.vue?vue&type=template&id=2ce8f575&scoped=true&"
import script from "./EditDeadlineModal.vue?vue&type=script&lang=js&"
export * from "./EditDeadlineModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDeadlineModal.vue?vue&type=style&index=0&id=2ce8f575&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8f575",
  null
  
)

export default component.exports